<p-toast></p-toast>
<div *ngIf="medico" class="container-ficha">
    <p-accordion [activeIndex]="0">
        <p-accordionTab header="Medico Perfil">
            <section *ngIf="medico">
                <div class="formgrid grid">
                    <div class="field col-12 md:col-4">
                        <label>Nombre </label>
                        <article
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            {{medico.nom_medico | uppercase}}</article>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label>Especialidad </label>
                        <article
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            <span *ngIf="medico.nomEspecialidad; else sin_especialidad"> {{medico.nomEspecialidad |
                                uppercase}} </span>
                            <ng-template #sin_especialidad>
                                Sin Especialidad
                            </ng-template>
                        </article>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label>Telefono Movil </label>
                        <article
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            <span *ngIf="medico.usuario.telefonoMovil; else sin_tel">{{medico.usuario.telefonoMovil
                                }}</span>
                            <ng-template #sin_tel>
                                Sin Telefono Movil
                            </ng-template>
                        </article>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label>Usuario</label>
                        <article
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            {{medico.usuario.usuario }}</article>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label>Contrasena</label>
                        <article
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            {{medico.usuario.contrasenia }}</article>
                    </div>
                    <div class="col-12  md:col-4">
                        <label>Puntos por default: </label>
                        <a href="javascript:void(0)" (click)="asignarpuntos(medico)">
                            {{medico.puntos}} </a>
                    </div>
                </div>
                <div class="formgrid grid">
                    <div class="col-12  md:col-4">
                        <label>Puntos generados: </label>
                        <span> {{puntosGenerados}} ({{saldo}})</span>
                    </div>
                    <div class="col-12  md:col-4">
                        <label>Puntos canjeados: </label>
                        <span>{{puntosCanjeados}}</span>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label>Saldo: </label>
                        <span>{{puntosGenerados - puntosCanjeados}} </span>
                    </div>
                </div>
                <!-- Modal de confirmación asignacion de puntos por default al medico -->
                <div class="modal" *ngIf="showModalPuntosDefault">
                    <div class="modal-content">
                        <section>
                            <h4 style="text-align: center;">Asignacion de puntos por default</h4>
                            <form id="catalogo" [formGroup]="puntosForm" (submit)="onSubmitPuntos()">
                                <div class="flex justify-content-center gap-3 pt-5">

                                    <p-dropdown [options]="catalogoPuntos" optionLabel="puntos" [filter]="false"
                                        [showClear]="true" formControlName="puntos" [emptyMessage]="'Sin registros'"
                                        [emptyFilterMessage]="'Sin resultados'" autoWidth="false"  [style]="{'width':'100%'}"
                                        placeholder="Seleccione una cantidad de puntos"></p-dropdown>

                                </div>
                            </form>
                        </section>

                        <div class="modal-buttons">
                            <button type="submit" form="catalogo" [disabled]="!puntosForm.valid"
                                class="btn-confirm">Confirmar</button>
                            <button type="button" (click)="cancelarAccionPuntosDefault()"
                                class="btn-cancel">Cancelar</button>
                        </div>
                    </div>
                </div>
            </section>
        </p-accordionTab>
        <p-accordionTab header="Casos Clínicos">
            <section *ngIf="medico">
                <p-toolbar styleClass="mb-4 gap-2">
                    <ng-template pTemplate="left">
                        <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                            (click)="exportExcel()"></button>
                    </ng-template>

                    <ng-template pTemplate="right">
                        <!-- 
                         <button pButton pRipple label="Reporte de productividad" icon="pi pi-file"
                            class="mr-2 inline-block" (click)="exportPDF()"></button>
                        -->

                    </ng-template>
                </p-toolbar>
                <p-table [value]="casosclinicos" [tableStyle]="{ 'min-width': '50rem', 'font-size': '12px' }" styleClass="p-datatable-sm">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Fecha</th>
                            <th>Caso Clínico</th>
                            <th>Paciente</th>
                            <th>Parte cuerpo</th>
                            <th>Hospital</th>
                            <th>No. Productos</th>
                            <th>No. Documentos</th>
                            <th>Enfermera</th>
                            <th>Acciones</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-casoclinico>
                        <tr>
                            <td>{{casoclinico.fecha | date:'dd/MM/yyyy'}}</td>
                            <td>
                                <a
                                    [routerLink]="['/administrador/casoclinico', casoclinico.id]">{{casoclinico.serie}}</a>
                            </td>
                            <td>{{casoclinico.paciente}}</td>
                            <td>{{casoclinico.nomCuerpo}}</td>
                            <td>{{casoclinico.nomHospital}}</td>
                            <td>{{casoclinico.productos?.length}}</td>
                            <td>{{casoclinico.documentos?.length}}</td>
                            <td *ngIf="casoclinico.fk_enfermera; else sinenfermera">{{casoclinico.fk_enfermera ?
                                (casoclinico.enfermera.nom_enfermera| uppercase) : 'Sin enfermera asignada'}}
                            </td>
                            <ng-template #sinenfermera>
                                <td>
                                    <a href="javascript:void(0)" (click)="asignarEnfermera(casoclinico)"> Sin Enfermera
                                    </a>
                                </td>
                            </ng-template>
                            <td>
                                <a [routerLink]="['/administrador/casoclinico/actualizar', casoclinico.id]">
                                    <i class="pi pi-pencil" style="color: slateblue"></i>
                                </a>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="9" class="text-center p-4">
                                <div class="flex flex-column align-items-center">
                                    <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                                    <span class="text-600 mt-2">No se encontraron casos clínicos</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            No. Registros: {{totalItemsCasosClinicos}}, Total páginas {{totalPaginasCasosClinicos}}
                        </div>
                    </ng-template>
                </p-table>
                <div class="card flex justify-content-center">
                    <p-paginator (onPageChange)="onPageChangeCasosClinicos($event)"
                        [first]="currentPageCasosClinicos.first" [rows]="currentPageCasosClinicos.rows"
                        [totalRecords]="totalItemsCasosClinicos"></p-paginator>
                </div>

                <!-- Modal de confirmación -->
                <div class="modal" *ngIf="showModal">
                    <div class="modal-content">
                        <section>
                            <h4 style="text-align: center;">Asignacion de puntos</h4>
                            <form id="catalogo" [formGroup]="enfermerasForm" (submit)="onSubmit()">
                                <div class="flex justify-content-center gap-3 pt-5">

                                    <p-dropdown [options]="catalogoEnfermeras" optionLabel="nom_enfermera"
                                        [filter]="false" [showClear]="true" formControlName="enfermera"
                                        [emptyMessage]="'Sin registros'" [emptyFilterMessage]="'Sin resultados'"
                                        placeholder="Seleccione enfermera"></p-dropdown>

                                </div>
                            </form>
                        </section>

                        <div class="modal-buttons">
                            <button type="submit" form="catalogo" [disabled]="!enfermerasForm.valid"
                                class="btn-confirm">Confirmar</button>
                            <button type="button" (click)="cancelarAccion()" class="btn-cancel">Cancelar</button>
                        </div>
                    </div>
                </div>
            </section>
        </p-accordionTab>
        <p-accordionTab header="Productos">
            <section *ngIf="medico">
                <p-table [value]="productos" [tableStyle]="{ 'min-width': '50rem', 'font-size': '12px' }" styleClass="p-datatable-sm">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Fecha</th>
                            <th>Código</th>
                            <th>Producto</th>
                            <th colspan="2">Caso Clínico</th>
                            <th>Canje</th>
                            <th>Puntos</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-producto>
                        <tr>
                            <td>{{producto.fechaAplicacion | date:'dd/MM/yyyy'}} </td>
                            <td>{{producto.codigo}} </td>
                            <td>{{producto.nomProducto}}</td>
                            <td>{{producto.casoclinico.serie}}</td>
                            <td>{{producto.casoclinico.nomHospital}}</td>
                            <td>
                                <span [ngClass]="{'solicitud': producto.status_canje === 1,
                                                'enproceso': producto.status_canje === 2, 
                                                'pagado': producto.status_canje === 3, 
                                                'cancelado': producto.status_canje === 4}">
                                    {{getCanje(producto.status_canje)}}</span>
                            </td>
                            <td>
                                <span
                                    *ngIf="producto.status_canje==0 || producto.status_canje==1 || producto.status_canje==2 ; else sinpuntos">
                                    <a href="javascript:void(0)" (click)="asignarpuntosproducto(producto)">
                                        {{producto.m_puntos}}</a>
                                </span>
                                <ng-template #sinpuntos>
                                    <span>{{producto.m_puntos}}</span>
                                </ng-template>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="6" class="text-center p-4">
                                <div class="flex flex-column align-items-center">
                                    <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                                    <span class="text-600 mt-2">No se encontraron códigos</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            No. Registros: {{totalItemsProductos}}, Total páginas {{totalPaginasProductos}}
                        </div>
                    </ng-template>
                </p-table>
                <div class="card flex justify-content-center">
                    <p-paginator (onPageChange)="onPageChangeProductos($event)" [first]="currentPageProductos.first"
                        [rows]="currentPageProductos.rows" [totalRecords]="totalItemsProductos"></p-paginator>
                </div>
                <!-- Modal de confirmación asignacion de puntos por producto al medico -->
                <div class="modal" *ngIf="showModalPuntosProducto">
                    <div class="modal-content">
                        <section>
                            <h4 style="text-align: center;">Asignacion de puntos al producto</h4>
                            <form id="catalogo" [formGroup]="puntosProductoForm" (submit)="onSubmitPuntosProducto()">
                                <div class="flex justify-content-center gap-3 pt-5">

                                    <p-dropdown [options]="catalogoPuntos" optionLabel="puntos" [filter]="false"
                                        [showClear]="true" formControlName="puntos" [emptyMessage]="'Sin registros'"
                                        [emptyFilterMessage]="'Sin resultados'" autoWidth="false"  [style]="{'width':'100%'}"
                                        placeholder="Seleccione una cantidad de puntos"></p-dropdown>

                                </div>
                            </form>
                        </section>

                        <div class="modal-buttons">
                            <button type="submit" form="catalogo" [disabled]="!puntosProductoForm.valid"
                                class="btn-confirm">Confirmar</button>
                            <button type="button" (click)="cancelarAccionPuntosProducto()"
                                class="btn-cancel">Cancelar</button>
                        </div>
                    </div>
                </div>
            </section>
        </p-accordionTab>
        <p-accordionTab header="Enfermeras">
            <section *ngIf="medico">
                <p-table [value]="enfermeras" [tableStyle]="{ 'min-width': '50rem', 'font-size': '12px' }" styleClass="p-datatable-sm">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Enfermera</th>
                            <th>Usuario</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-enfermera>
                        <tr>
                            <td>{{enfermera.nom_enfermera}} </td>
                            <td>{{enfermera.correo}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="2" class="text-center p-4">
                                <div class="flex flex-column align-items-center">
                                    <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                                    <span class="text-600 mt-2">No se encontraron enfermeras</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            No. Registros: {{totalItemsEnfermeras}}, Total paginas {{totalPaginasEnfermeras}}
                        </div>
                    </ng-template>
                </p-table>
                <div class="card flex justify-content-center">
                    <p-paginator (onPageChange)="onPageChangeEnfermeras($event)" [first]="currentPageEnfermeras.first"
                        [rows]="currentPageEnfermeras.rows" [totalRecords]="totalItemsEnfermeras"></p-paginator>
                </div>
            </section>
        </p-accordionTab>
        <p-accordionTab header="Canjes">
            <section *ngIf="medico">
                <!--
                    <p-toolbar styleClass="mb-4 gap-2">
                        <ng-template pTemplate="left">
                            <button pButton pRipple [label]="'Nuevo Canje'" icon="pi pi-plus"
                                (click)="nuevoCanje()"></button>
                        </ng-template>
    
                    </p-toolbar>
                -->
                <p-table [value]="canjes" [tableStyle]="{ 'min-width': '50rem', 'font-size': '12px' }" styleClass="p-datatable-sm">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Fecha</th>
                            <th>Cantidad</th>
                            <th>Status</th>
                            <th colspan="2">Acciones</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-canje>
                        <tr>
                            <td>{{canje.fechaInicio | date:'dd/MM/yyyy'}} </td>
                            <td>{{canje.redimir}}</td>
                            <td><span
                                    [ngClass]="{'enproceso': canje.status === 2, 'pagado': canje.status === 3, 'cancelado': canje.status === 4}">{{getCanje(canje.status)}}</span>
                            </td>
                            <td><a *ngIf="(canje.status === 2 || canje.status === 1)"
                                    [routerLink]="['../../medico/atender/canje', canje.id]"><i class="pi pi-pencil"
                                        style="color: slateblue"></i></a> </td>
                            <td><a *ngIf="(canje.status === 3)" [routerLink]="['../../medico/vista/canje', canje.id]"><i
                                        class="pi pi-eye" style="color: slateblue"></i></a> </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="5" class="text-center p-4">
                                <div class="flex flex-column align-items-center">
                                    <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                                    <span class="text-600 mt-2">No se encontraron canjes</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            No. Registros: {{totalItemsCanjes}}, Total paginas {{totalPaginasCanjes}}
                        </div>
                    </ng-template>
                </p-table>
                <div class="card flex justify-content-center">
                    <p-paginator (onPageChange)="onPageChangeCanjes($event)" [first]="currentPageCanjes.first"
                        [rows]="currentPageCanjes.rows" [totalRecords]="totalItemsCanjes"></p-paginator>
                </div>
            </section>
        </p-accordionTab>
    </p-accordion>
    <div class="mt-3">
        <p-button type="button" label="Regresar" (click)="regresar()" styleClass="p-button-sm"></p-button>
    </div>
</div>